import { connect } from "react-redux";
import useScreen from "../../../providers/screen";
import { Col, Row } from "./style";

const Container = ({ header, children, carts, theme }) => {
  const { screen } = useScreen();

  return (
    <>
      <Row
        className="row no-gutters"
        header={header}
        isDesktop={screen?.isDesktop}
        theme={theme}
      >
        <Col className="col-12" isDesktop={screen?.isDesktop}>
          {children}
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Container);
